// import FastfoodIcon from "@mui/icons-material/Fastfood";
import FacebookIcon from '@mui/icons-material/Facebook';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import Link from '@mui/material/Link';
import { makeStyles } from "@mui/styles";
import * as React from "react";
const useStyles = makeStyles(() => ({
  missingOppositeContent: {
    '&:before': {
      display: 'none'
    },
    '&.after': {
      display: 'none'
    }

  },
  MuiTimelineConnectorRoot: {
    backgroundColor: '#d60 !important'
  },
  Iconstyle: {
    color: 'white',
    backgroundColor: '#0a648f !important',
    cursor: 'pointer'
  },
  link: {
    backgroundColor: 'none',
    textDecoration: 'none',
  }
}));

export default function SocialLine() {
  const classes = useStyles();
  return (
    <Timeline>
      <TimelineItem className={classes.missingOppositeContent}>
        <TimelineSeparator>
          {/* <TimelineConnector /> */}
          <Link href="https://www.facebook.com/zaman.rabeen" target={"_blank"}>
            <TimelineDot className={classes.Iconstyle}>
              <FacebookIcon />
            </TimelineDot>
          </Link>
          <TimelineConnector />
        </TimelineSeparator>
      </TimelineItem>
      <TimelineItem className={classes.missingOppositeContent}>
        <TimelineSeparator>
          <TimelineConnector />
          <Link href="https://www.linkedin.com/in/zaman-rabeen/" target={"_blank"}>
          <TimelineDot className={classes.Iconstyle}>
            <LinkedInIcon />
          </TimelineDot>
          </Link>
          <TimelineConnector />
        </TimelineSeparator>
      </TimelineItem>
      <TimelineItem className={classes.missingOppositeContent}>
        <TimelineSeparator>
          <TimelineConnector />
          <Link href="https://www.github.com/zamanrabeen671" target={"_blank"}>
          <TimelineDot className={classes.Iconstyle}>
            <GitHubIcon />
          </TimelineDot>
          </Link>
          <TimelineConnector />
        </TimelineSeparator>
      </TimelineItem>
      <TimelineItem className={classes.missingOppositeContent}>
        <TimelineSeparator>
          <TimelineConnector />
          <Link href="https://www.facebook.com/zaman.rabeen" target={"_blank"}>
          <TimelineDot className={classes.Iconstyle}>
            <RssFeedIcon />
          </TimelineDot>
          </Link>
          {/* <TimelineConnector /> */}
        </TimelineSeparator>
      </TimelineItem>
    </Timeline>
  );
}
